import * as React from 'react';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../redux';
import {onMessage} from 'firebase/messaging';

import {addOrUpdateNotification} from '../../redux/actions/profile';
import {holderProfileSelector} from '../../redux/selectors/profile';
import {fcmNotificationType} from '../constants/fcmNotificationType';
import {NotificationResponsePayload} from '../models/api';
import {syncFCMState} from '../routing/navigation';
import {messaging} from './service/messaging.web';
import {FcmServiceWeb, WebFirebaseNotification} from './service/service.web';

const fcmService = new FcmServiceWeb();

export const useFcmWrapper = () => {
  const dispatch = useAppDispatch();
  const holderProfile = useSelector(holderProfileSelector());

  const onCheckUpdates = async () => {
    if (holderProfile) {
      let token = null;
      try {
        token = await fcmService.getToken();
      } catch {
      } finally {
        const needManualSync = !messaging || !token;
        if (needManualSync) {
          syncFCMState(dispatch);
        }
      }
    }
  };

  React.useEffect(() => {
    onCheckUpdates();
  }, [holderProfile]);

  React.useEffect(() => {
    const unsubscribe = messaging
      ? onMessage(messaging, (payload) => fcmService.messageHandler(payload as unknown as WebFirebaseNotification))
      : undefined;

    return () => {
      unsubscribe && unsubscribe();
    };
  }, []);

  React.useEffect(() => {
    window.addEventListener('focus', onCheckUpdates);
    return () => {
      window.removeEventListener('focus', onCheckUpdates);
    };
  });

  // TODO: may be move in another place
  const processMessage = async (remoteMessage: WebFirebaseNotification) => {
    if (!remoteMessage?.data?.type) {
      return;
    }

    try {
      switch (remoteMessage.data.type) {
        case fcmNotificationType.addOrUpdateNotification:
          if (!remoteMessage.data.payload) {
            return;
          }

          const notification = JSON.parse(remoteMessage.data.payload) as NotificationResponsePayload;
          dispatch(addOrUpdateNotification(notification));
          break;
      }
    } catch (e) {
      console.error(e);
    }
  };

  React.useEffect(() => {
    fcmService.registerMessageHandler(processMessage);

    return fcmService.unregisterMessageHandler.bind(fcmService);
  }, []);
};

export {fcmService};
